import React, { useState } from "react";
import { motion } from "framer-motion";
import "../styles/Contact.css";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const Contact = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formError, setFormError] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!firstName || !lastName || !email) {
      setFormError("Please fill all the required fields!");
      toast.error("Please fill all the required fields!");
      return;
    }
    setFormError("");
    setIsSubmitting(true);
    const payload = {
      firstName: firstName,
      lastName: lastName,
      phonenumber: phoneNumber,
      email: email,
      message: message,
      type: "contact"
    };
    try {
      const response = await axios.post(
        "https://tnreaders.in/web/contact",
        payload
      );
      if (response.status === 200) {
        toast.success("Your message has been submitted successfully.");
        setFirstName("");
        setLastName("");
        setEmail("");
        setMessage("");
      }
    } catch (error) {
      toast.error("Error submitting the form. Please try again!");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <>
      <div className="contactssect">
        <div style={{ marginBottom: "36px", marginTop: "30px" }}>
          <div className="">
            <div className="buildercontact">
              <div className="buiderimage12">
                <h2
                  className="contactstitle"
                  style={{ color: "white", textAlign: "left" }}
                >
                  Our <span style={{ color: "#FBBC04" }}> Support </span> Team
                  is here to <span style={{ color: "#FBBC04" }}> help </span>{" "}
                  you
                </h2>
                <p
                  className="fsp"
                  style={{ color: "white", textAlign: "left" }}
                >
                  Get in touch and let us know how we can help...!
                </p>
              </div>
              <div className="builderimage">
                <div className="d-flex flex-column">
                  <img
                    className="builderimages"
                    src="/images/grouped.webp"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="contact-container">
          <motion.div
            className="contact-info"
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h4
              className=""
              style={{
                textAlign: "left",
                marginBottom: "52px",
                fontWeight: "600",
                fontSize: "36px",
                color: "#137eb1"
              }}
            >
              CONTACT US-
            </h4>
            <div className="contact-methods">
              <div className="contact-methods1">
                <div>
                  <img
                    className="conmethimag"
                    src="/images/callme.webp"
                    alt=""
                  />
                </div>
                <div>
                  <h2>Phone</h2>
                  <p>+91 8508508590</p>
                </div>
              </div>
              <div className="contact-methods1">
                <div>
                  <img
                    className="conmethimag"
                    src="/images/mailme.webp"
                    alt=""
                  />
                </div>
                <div>
                  <h2>Email</h2>
                  <p>
                    <strong>HR: </strong>
                    <a className="fsp" href="mailto:hr@mpeoples.in">
                      hr@mpeoples.in
                    </a>
                  </p>
                  <p>
                    <strong>Support: </strong>
                    <a className="fsp" href="mailto:support@mpeoples.in">
                      support@mpeoples.in
                    </a>
                  </p>
                </div>
              </div>
              <div className="contact-methods1">
                <div>
                  <img
                    className="conmethimag"
                    src="/images/mapme.webp"
                    alt=""
                  />
                </div>
                <div>
                  <h2>Office Address</h2>
                  <p>
 No 56/3-1 Ranga Nagar, 3rd Cross Street, <br />
                    Suramangalam, Salem-636005.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
          <motion.div
            className="contact-form"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h2 className="fsh3">Enquiry</h2>
            {formError && <p className="form-error">{formError}</p>}
            <form onSubmit={handleSubmit}>
              <div className="twooo">
                <motion.div
                  className="input-group d-flex flex-column justify-content-md-start justify-content-center align-items-md-start align-items-center rounded"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  <label className="fsp">First Name</label>
                  <input
                    type="text"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    placeholder="First Name"
                    className="input-fields"
                    required
                  />
                </motion.div>
                <motion.div
                  className="input-group d-flex flex-column justify-content-md-start justify-content-center align-items-md-start align-items-center rounded"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: 0.1 }}
                >
                  <label className="fsp">Last Name</label>
                  <input
                    type="text"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    placeholder="Last Name"
                    className="input-fields"
                    required
                  />
                </motion.div>
              </div>
              <div className="twooo">
                <motion.div
                  className="input-group d-flex flex-column justify-content-md-start justify-content-center align-items-md-start align-items-center rounded"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                >
                  <label className="fsp">Phone</label>
                  <input
                    type="tel"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    placeholder="Mobile number"
                    className="input-fields"
                    required
                  />
                </motion.div>
                <motion.div
                  className="input-group d-flex flex-column justify-content-md-start justify-content-center align-items-md-start align-items-center rounded"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                >
                  <label className="fsp">Email</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email"
                    className="input-fields"
                    required
                  />
                </motion.div>
              </div>
              <motion.div
                className="input-group d-flex flex-column justify-content-md-start align-items-md-start rounded"
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.3 }}
              >
                <label className="fsp">Leave your message</label>
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Your Message"
                  className="input-fields"
                  style={{ height: "162px" }}
                  required
                />
              </motion.div>
              <motion.button
                type="submit"
                className="button"
                disabled={isSubmitting}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </motion.button>
            </form>
          </motion.div>
        </div>
        <div className="m1">
          <div className="builder">
            <div className="builderimage">
              <img
                src={"/images/guy.webp"}
                alt=""
                style={{
                  height: "236px",
                  marginBottom: "32px",
                  textShadow: "2px 2px 4px #000000"
                }}
              />
            </div>
            <div className="buiderimage12">
              <h2 className="buiderimage1h2 fsh2" style={{ color: "white" }}>
                Better discussions, better decisions
              </h2>
              <p className="buiderimage1h2" style={{ color: "#FBBC04" }}>
                We are for everyone - Startups, SMBs, Enterprises. Connect with
                us for a conversation.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Contact;
